import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface TitleProps {
  icon?: React.ReactNode | null;
  title: string;
}

export default function Title(props: Readonly<TitleProps>) {
  const { icon, title } = props;

  return (
    <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
      <Stack spacing={1} direction="row" width="70%" justifyContent="flex-start" alignItems="flex-end">
        {icon}
        <Typography component="span" fontWeight="bold">
          {title}
        </Typography>
      </Stack>
      <Typography p="12px">{'Mail'}</Typography>
      <Typography p="12px">{'App'}</Typography>
    </Stack>
  );
}
